import {
  Box,
  Paper,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { SortableHeaderProps } from './types';

export default function SortableHeader<T>({
  columns,
  order,
  orderBy,
  onRequestSort,
  hasAction
}: SortableHeaderProps<T>) {
  const createSortHandler =
    (property: keyof T) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.id as string}
            align={column.options?.align ? column.options.align : 'left'}
            padding={column.options?.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === column.id ? order : false}
            style={{
              fontSize: '14px',
              lineHeight: '21px',
              fontFamily: 'Open Sans',
              color: '#767676',
              fontWeight: '600'
            }}
          >
            {column.label && (
              <TableSortLabel
                active={orderBy === column.id}
                direction={orderBy === column.id ? order : 'asc'}
                onClick={createSortHandler(column.id)}
                style={{
                  fontSize: '14px',
                  lineHeight: '21px',
                  fontFamily: 'Open Sans',
                  color: '#767676',
                  fontWeight: '600'
                }}
              >
                {column.label}
                {orderBy === column.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
        {hasAction && <TableCell>{/* empty */}</TableCell>}
      </TableRow>
    </TableHead>
  );
}
